/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import React, { useCallback } from 'react';
import {
  Box, Grid, Skeleton,
} from '@mui/material';
import LoadingOverlay from '../../../Components/LoadingOverlay';
import TimeSlotSkeleton from '../../../Components/Skeleton/TimeSlotSkeleton';

/**
 * AppointmentFormSkeleton Component
 * @returns {Element}
 * @constructor
 */
export default function AppointmentFormSkeleton() {
  const renderSkeletons = useCallback(() => {
    // Array to store 10 instances of the SkeletonComponent
    const skeletons = [];

    // Loop to create 10 instances of the SkeletonComponent
    for (let i = 1; i <= 10; i += 1) {
      skeletons.push(<Grid key={i} xs={6} item><TimeSlotSkeleton /></Grid>);
    }

    return skeletons;
  }, []);

  return (
    <>
      <LoadingOverlay />
      <Grid item xs={12} className="date-container">
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item container xs={3} justifyContent="center" alignItems="center">
            <Skeleton variant="circular" width={50} height={50} />
          </Grid>
          <Grid item xs={6} justifyContent="center" alignItems="center">
            <Box><Skeleton variant="text" sx={{ fontSize: '48px' }} /></Box>
            <Box><Skeleton variant="text" sx={{ fontSize: '32px' }} /></Box>
          </Grid>
          <Grid item container xs={3} justifyContent="center" alignItems="center">
            <Skeleton variant="circular" width={50} height={50} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className="appointment-container">
        <Grid container rowSpacing={1} columnSpacing={3}>
          {renderSkeletons()}
        </Grid>
      </Grid>
    </>
  );
}
